// extracted by mini-css-extract-plugin
module.exports = {"DatePicker":"PlannedTourCopyingModal_DatePicker__32nZ0","Result":"PlannedTourCopyingModal_Result__tdhsF"};